import {useGetUserProfile} from "@framework/auth/use-get-user-profile";
import {Nullable, User} from "@framework/types";

export type AuthContext = {
    loading: boolean;
    isAuthenticated: boolean;
    user: Nullable<User>
}

export const useAuthContext = (): AuthContext => {
    const {data: user, isLoading} = useGetUserProfile();

    return {
        loading: isLoading,
        isAuthenticated: !!user,
        user: user ?? null
    }
}